import { IEsgDataPlatform } from '@Domains/Esg/EsgDataPlatform';
import { IGreenhouse } from '@Domains/Esg/EsgGreenhouse';
import { ESG_PLAN } from '@Domains/Esg/EsgPlan';
import { VerifyType } from 'src/Enum/EsgGreenhouse';
import { EsgPlansFormValues } from '../EsgPlans';

export const getEmptyGreenhouseData = (data?: IGreenhouse): IGreenhouse => {
  return {
    ...data,
    greenhouseStandard: data?.greenhouseStandard ?? {
      remark: {},
      principles: [],
      completedSection: {
        isCompletedTh: false,
        isCompletedEn: false,
      },
    },
    greenhouseGoalTerm: data?.greenhouseGoalTerm ?? {},
    greenhouseStrategy: data?.greenhouseStrategy ?? {
      plan: {},
    },
    climateChangeStructure: data?.climateChangeStructure ?? {
      committee: [],
    },
    performanceGhGasMgmtReport: data?.performanceGhGasMgmtReport ?? {
      performanceGhGasMgmt: {
        result: VerifyType.NO,
      },
    },
    otherDescriptions: data?.otherDescriptions ?? [],
    completedSection: data?.completedSection ?? {
      id: data?.completedSection?.id,
      isCompletedTh: false,
      isCompletedEn: false,
    },
  };
};

export const getEmptyEsgDataPlatform = (
  data?: IEsgDataPlatform
): IEsgDataPlatform => {
  return {
    esgDataPlatform: {
      introduction: undefined,
      remark: undefined,
    },
    otherDescriptions: [],
    completedSection: {
      id: data?.completedSection?.id ?? undefined,
      isCompletedTh: false,
      isCompletedEn: false,
    },
  };
};

export const mapEsgCharacteristic = (
  characteristicTypes?: Array<ESG_PLAN>,
  defaultValues?: EsgPlansFormValues
) => {
  const esgCharacters = { ...defaultValues };

  characteristicTypes?.forEach((characteristicType) => {
    if (characteristicType === ESG_PLAN.DATA_PLATFORM) {
      esgCharacters.esgPlatform = true;
    }
    if (characteristicType === ESG_PLAN.GREEN_HOUSE) {
      esgCharacters.esgGreenhouse = true;
    }
  });

  return esgCharacters;
};
